import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  NgControl,
  ReactiveFormsModule,
  ValidationErrors,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { PostalAddress, PostalAddressFormGroup } from '@app/features/companies/postal-adress.model';
import { ToUppercaseDirective } from '../../pipes/to-uppercase.directive';

@Component({
  selector: 'app-postal-address-form',
  imports: [
    CommonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    ToUppercaseDirective,
  ],
  templateUrl: './postal-address-form.html',
  styleUrls: ['./postal-address-form.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PostalAddressForm),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PostalAddressForm),
      multi: true,
    },
  ],
})
export class PostalAddressForm {
  @Input({ required: true }) formGroup!: PostalAddressFormGroup;
  @Output() valueChange = new EventEmitter<PostalAddress>();

  public ngControl?: NgControl;

  get isValid(): boolean {
    return this.formGroup.valid;
  }
  onChange: (value: PostalAddress) => void = () => {
    // Intentionally left empty
  };
  onTouched: () => void = () => {
    // Intentionally left empty
  };

  writeValue(value: PostalAddress): void {
    if (value) {
      this.formGroup.patchValue(value);
    } else {
      this.formGroup.reset();
    }
  }

  registerOnChange(fn: (value: PostalAddress) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  validate(): ValidationErrors | null {
    return this.formGroup.errors;
  }
}
